/**
 * THIS IS TBD - a temporary global store for state values
 * This should be replaced with an actual library for managing global state that is better than this hack
 */
import { v4 as uuidv4 } from 'uuid'

export let clientSideContextStore = null

export type ContextStore<TValues = any> = {
  values?: TValues
  get?: any
  set?: any
  getAll?: any
  getNamespace?: any
  setAll?: any
  hydrate?: any
}

export type ContextStoreOptions = {
  contextState?: any
}

export const createContextStore = (options: ContextStoreOptions = null) => {
  const store: ContextStore = {
    values: {
      id: uuidv4(),
    },
  }

  store.get = key => {
    return store.values[key]
  }
  store.getNamespace = namespaceKey => {
    const keys = Object.keys(store.values)
    const namespaceValues = {}
    for (const key of keys) {
      if (key.indexOf(namespaceKey) === 0) {
        namespaceValues[key.replace(`${namespaceKey}.`, '')] = store.values[key]
      }
    }

    return namespaceValues
  }
  store.getAll = () => {
    return store.values
  }
  store.set = (key, value) => {
    return (store.values[key] = value)
  }
  store.setAll = values => {
    store.values = { ...store.values, ...values }
  }
  store.hydrate = values => {
    store.values = { ...store.values, ...values }
  }

  if (options?.contextState) {
    store.hydrate(options.contextState)
  }

  return store
}

export const getClientSideContextStore = contextState => {
  if (!clientSideContextStore) {
    clientSideContextStore = createContextStore({ contextState })
  }

  return clientSideContextStore
}
